// ITEM-19: detect a persisted rebuild-backed grouped meal and derive its metadata-only edit affordances.
// Detection uses PERSISTED data — the server 'rebuild_v2' marker or any component carrying an authoritative
// nested `rebuilt` provenance block — NOT the meal-level workflow source (e.g. AI_PHOTO_LOG).

export const isRebuiltPersistedMeal = (data, ingredients) =>
  Boolean(data && data.rebuild_v2) ||
  (Array.isArray(ingredients) && ingredients.some((i) => i && i.rebuilt));

// Until a rebuild-aware post-log recompute exists, a rebuild-backed meal is metadata-only in Edit:
// no macro inputs, no Add Ingredient, ingredient rows read-only; name/photo remain editable.
export const rebuildEditAffordances = (isRebuiltMeal) => ({
  showMacroInputs: !isRebuiltMeal,
  showAddIngredient: !isRebuiltMeal,
  ingredientRowsReadOnly: Boolean(isRebuiltMeal),
  nameEditable: true,
  photoEditable: true,
});
